import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\n<rect x=\"37.5\" y=\"21.25\" width=\"3.75\" height=\"25\" rx=\"1.875\" />\n<path d=\"M27.5 28.75L39.375 20L51.25 28.75\" fill=\"none\" stroke-width=\"3.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path fill=\"none\" d=\"M18.75 41.25V51.25C18.75 55.3921 22.1079 58.75 26.25 58.75H52.5C56.6421 58.75 60 55.3921 60 51.25V41.25\" stroke-width=\"3.75\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol